import { setToken, getToken } from '@/libs/util'

export default {
  state: {
    userId: '',
    avatorImgPath: '',
    token: getToken(),
    access: [],
    hasGetInfo: true,
    unreadCount: 0,
    messageUnreadList: [],
    messageReadedList: [],
    messageTrashList: [],
    messageContentStore: {},
    userName: '',
    poster: ''
  },
  mutations: {
    setAvator (state, avatorPath) {
      state.avatorImgPath = avatorPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setUserName (state, name) {
      state.userName = name
      localStorage.setItem('userName', name)
    },
    // 浏览器刷新完成从storage还原state
    recovery (state) {
      state.userName = localStorage.getItem('userName')
      state.access = JSON.parse(localStorage.getItem('access'))
    },
    setAccess (state, access) {
      state.access = access
      localStorage.setItem('access', JSON.stringify(access))
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setMessageCount (state, count) {
      state.unreadCount = count
    },
    setMessageUnreadList (state, list) {
      state.messageUnreadList = list
    },
    setMessageReadedList (state, list) {
      state.messageReadedList = list
    },
    setMessageTrashList (state, list) {
      state.messageTrashList = list
    },
    updateMessageContentStore (state, { msg_id, content }) {
      state.messageContentStore[msg_id] = content
    },
    moveMsg (state, { from, to, msg_id }) {
      const index = state[from].findIndex(_ => _.msg_id === msg_id)
      const msgItem = state[from].splice(index, 1)[0]
      msgItem.loading = false
      state[to].unshift(msgItem)
    }
  },
  getters: {
    messageUnreadCount: state => state.messageUnreadList.length,
    messageReadedCount: state => state.messageReadedList.length,
    messageTrashCount: state => state.messageTrashList.length
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { userName, password }) {
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          userName,
          password
        }).then(res => {
          const data = res.data
          commit('setToken', data.token)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      commit('setAccess', [])
    },
    // 设置用户相关信息
    getUserInfo ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit('setAccess', payload)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    }

  }
}
